import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchAmritVarshaDetailsAction } from '../../../utils/redux/amritVarsha/amritVarshaAction';
import { Card, Col, Container, Row } from 'react-bootstrap';
import '../CSS/commondetails.css';

const AmritVarshaDetails = () => {
    const { id } = useParams();
    const { selectedAmritVarsha } = useSelector(state => state.amritVarsha);

    const dispatch = useDispatch();

    const fetchNuggetDetails = async () => {
        await dispatch(fetchAmritVarshaDetailsAction(id));
    };

    useEffect(() => {
        fetchNuggetDetails();
    }, []);

    if (!selectedAmritVarsha)
        return <>Loading...</>;

    return (
        <Container className="py-4">
            <Card className="talk-details-card">
                <Card.Body>
                    {/* Title Section */}
                    <div className="title-section mb-4">
                        <h2>{selectedAmritVarsha?.title || "No title available"}</h2>
                    </div>

                    <Row className="mb-4">
                        {/* Basic Information Column */}
                        <Col md={6}>
                            <div className="detail-section">
                                <h5 className="section-title">Basic Information</h5>
                                <div className="info-content">
                                    <div className="detail-item">
                                        <span className="label">Nugget Exist:</span>
                                        <span>{selectedAmritVarsha?.nugget ? "Yes" : "No"}</span>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        {/* Links Column */}
                        <Col md={6}>
                            <div className="detail-section">
                                <h5 className="section-title">Links</h5>
                                <div className="info-content">
                                    <div className="detail-item">
                                        <span className="label">Amrit Varsha Link:</span>
                                        {selectedAmritVarsha?.link ? (
                                            <a href={selectedAmritVarsha?.link} target="_blank" rel="noopener noreferrer">
                                                Amrit Varsha Link
                                            </a>
                                        ) : (
                                            <span className="text-muted">No Amrit Varsha link available</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Description Section */}
                    <div className="detail-section mb-4">
                        <h5 className="section-title">Manual</h5>
                        <div className="content-section">
                            <div className="content-text formatted-text">
                                {selectedAmritVarsha?.manual ?
                                    selectedAmritVarsha?.manual.split('\n').map((paragraph, index) => (
                                        <p key={index}>{paragraph}</p>
                                    ))
                                    : "No Transcription added yet"}
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    )
}

export default AmritVarshaDetails